import React, { useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

import CheckoutFormTest from './CheckoutFormTest'
import '../../styles/components/_stripe.scss'
import { STRIPE_KEY, STRIPE_URL } from '../../config'
import { useTranslation } from 'react-i18next'
import { CircularProgress } from '@mui/material'
import CheckoutFormSubscriptionTest from './CheckoutFormSubscriptionTest'

// Make sure to call loadStripe outside of a component's render to avoid
// recreating the Stripe object on every render.
// This is a public sample test API key.
// Don't submit any personally identifiable information in requests made with this key.
// Sign in to see your own test API key embedded in code samples.
// Stripe publish key
const stripePromise = loadStripe(STRIPE_KEY)

export default function StripeSubscriptionTest({
  userId,
  offreId,
  offrePeriode = 0,
  type = 'subscription_monthly',
  offrePrice,
  onSuccess,
  onClose,
  codePromoObject,
  offreQuantity = 1,
}) {
  const { i18n } = useTranslation()
  const [clientSecret, setClientSecret] = useState('')
  const [subscriptionId, setSubscriptionId] = useState('')
  const [loading, setLoading] = useState(true)

  console.log(
    'StripeSubscriptionTest:',
    userId,
    offreId,
    offrePeriode,
    type,
    offrePrice,
    offreQuantity
  )

  useEffect(() => {
    // Reset state when price or quantity changes
    setClientSecret('')
    setSubscriptionId('')
    setLoading(true)

    // Créer Subscription dès que la page se charge
    fetch(`${STRIPE_URL}create_subscription`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id_offre: offreId,
        type: type,
        periode: offrePeriode,
        id_client: userId,
        prix: parseInt(offrePrice),
        quantity: offreQuantity,
        devise: sessionStorage.getItem('currency')
          ? JSON.parse(sessionStorage.getItem('currency')).devise
          : 'CHF',
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setClientSecret(data.clientSecret)
        setSubscriptionId(data.subscriptionId)
        setLoading(false)
      })
      .catch((error) => {
        console.error('Error creating subscription:', error)
        setLoading(false)
      })
  }, [userId, offreId, offrePeriode, offrePrice, type, offreQuantity])

  const appearance = {
    theme: 'stripe',
  }
  const options = {
    clientSecret,
    appearance,
    locale: i18n.language,
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <div className="App">
      <Elements options={options} stripe={stripePromise}>
        <CheckoutFormSubscriptionTest
          paymentIntentId={subscriptionId}
          userId={userId}
          offrePrice={offrePrice}
          offreId={offreId}
          type={type}
          periode={offrePeriode}
          onSuccess={onSuccess}
          onClose={onClose}
          codePromoObject={codePromoObject}
          offreQuantity={offreQuantity}
        />
      </Elements>
    </div>
  )
}
